import { Injectable, inject } from "@angular/core";
import { of } from "rxjs";
import { catchError, shareReplay } from "rxjs/operators";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "app/app.settings";

@Injectable({
   providedIn: "root"
})
export class TranslationService {
   private http = inject(HttpClient);
   private appSettings = inject(AppSettings);

   private readonly baseUri: string;
   private readonly endpoint: string;

   // one request per language + key; failed requests are removed so they are retried
   private readonly cache = new Map<string, Observable<string>>();

   public readonly translationError = "***ERROR***";

   constructor() {
      this.baseUri = `${this.appSettings.baseCoreApiUrl}`;
      this.endpoint = `text-fragment`;
   }

   public getTranslation(key: string): Observable<string> {
      if (!key) {
         return of("");
      }

      const language = this.appSettings.selectedLanguage;
      const cacheKey = `${language}|${key}`;
      const cached = this.cache.get(cacheKey);
      if (cached) {
         return cached;
      }

      const uri = `${this.baseUri}/${this.endpoint}?code=${key}&language=${language}`;
      const defaultRequestHeaders = new HttpHeaders()
         .set("Content-Type", "text/plain; charset=utf-8")
         .append("X-MY-CLOUD-No-Response-Toast", "true");

      const defaultRequestOptions: Object = {
         headers: defaultRequestHeaders,
         responseType: "text" as "json"
      };

      const translation = this.http.get<string>(uri, defaultRequestOptions).pipe(
         catchError(_ => {
            this.cache.delete(cacheKey);
            return of(this.translationError);
         }),
         shareReplay(1)
      );

      this.cache.set(cacheKey, translation);
      return translation;
   }
}
